"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHttpErrorPage_styled_exports = {};
__export(GlobalHttpErrorPage_styled_exports, {
  StyledAdditionalErrorMessage: () => StyledAdditionalErrorMessage,
  StyledAllButtonsContainer: () => StyledAllButtonsContainer,
  StyledButton: () => StyledButton,
  StyledCopyButton: () => StyledCopyButton,
  StyledErrorImage: () => StyledErrorImage,
  StyledErrorPageContainer: () => StyledErrorPageContainer,
  StyledHttpErrorCode: () => StyledHttpErrorCode,
  StyledHttpErrorMessage: () => StyledHttpErrorMessage,
  StyledIcon: () => StyledIcon,
  StyledImageBox: () => StyledImageBox,
  StyledLabel: () => StyledLabel,
  StyledTextAndButtonContainer: () => StyledTextAndButtonContainer,
  StyledTextArea: () => StyledTextArea,
  StyledTextAreaAndCopyButtonContainer: () => StyledTextAreaAndCopyButtonContainer,
  StyledTextAreaAndLabelContainer: () => StyledTextAreaAndLabelContainer,
  StyledTextMessageContainer: () => StyledTextMessageContainer
});
module.exports = __toCommonJS(GlobalHttpErrorPage_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_atoms = require("../../atoms");
var import_mixins = require("../../../themes/mixins");
var StyledIcon = import_styled_components.default.img.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledIcon",
  componentId: "sc-el4wx8-0"
})(["width:28px;height:28px;padding-left:", ";"], function(_ref) {
  var theme = _ref.theme;
  return theme.measurements.medium;
});
var StyledErrorPageContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledErrorPageContainer",
  componentId: "sc-el4wx8-1"
})(function() {
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;flex-direction:column;margin:0 auto;", ""], (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["flex-direction:row-reverse;margin-top:104px;"])));
});
var StyledImageBox = (0, import_styled_components.default)(StyledIcon).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledImageBox",
  componentId: "sc-el4wx8-2"
})(function() {
  return (0, import_styled_components.css)(["box-sizing:border-box;width:80px;height:80px;padding:0;margin:40px 0 32px 0;", " ", ""], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["margin-top:80px;"])), (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["margin-top:40px;"])));
});
var StyledTextAndButtonContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledTextAndButtonContainer",
  componentId: "sc-el4wx8-3"
})(function() {
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;flex-direction:column;width:288px;margin:0 auto;", " ", ""], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["width:420px;"])), (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["width:583px;margin-left:50px;"])));
});
var StyledTextMessageContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledTextMessageContainer",
  componentId: "sc-el4wx8-4"
})(function() {
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;flex-direction:column;width:100%;"]);
});
var StyledHttpErrorMessage = (0, import_styled_components.default)(import_atoms.Heading).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledHttpErrorMessage",
  componentId: "sc-el4wx8-5"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["box-sizing:border-box;color:", ";font-weight:", ";font-size:", ";line-height:32px;padding:0px;margin-bottom:4px;"], theme.colors.black, theme.typography.weights.regular, theme.typography.sizes.extraExtraLarge);
});
var StyledHttpErrorCode = (0, import_styled_components.default)(import_atoms.Heading).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledHttpErrorCode",
  componentId: "sc-el4wx8-6"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["box-sizing:border-box;color:", ";font-weight:", ";font-size:", ";line-height:24px;padding:0px;margin-bottom:8px;"], theme.colors.black, theme.typography.weights.regular, theme.typography.sizes.medium);
});
var StyledAdditionalErrorMessage = (0, import_styled_components.default)(StyledHttpErrorCode).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledAdditionalErrorMessage",
  componentId: "sc-el4wx8-7"
})(function() {
  return (0, import_styled_components.css)(["box-sizing:border-box;"]);
});
var StyledAllButtonsContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledAllButtonsContainer",
  componentId: "sc-el4wx8-8"
})(function(_ref4) {
  var alignment = _ref4.alignment;
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;flex-direction:column;margin-top:", ";", ""], alignment === "right" ? "8px" : "32px", (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["flex-direction:row;", ""], alignment === "right" && "justify-content: flex-end;")));
});
var StyledErrorImage = (0, import_styled_components.default)(StyledIcon).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledErrorImage",
  componentId: "sc-el4wx8-9"
})(function() {
  return (0, import_styled_components.css)(["box-sizing:border-box;width:288px;height:219px;padding:0;margin:32px auto 56px auto;", " ", ""], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["width:420px;height:320px;"])), (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["width:460px;height:408px;margin-right:50px;"])));
});
var StyledButton = (0, import_styled_components.default)(import_atoms.Button).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledButton",
  componentId: "sc-el4wx8-10"
})(function() {
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;width:100%;margin-bottom:8px;height:40px;justify-content:center;align-items:center;", " ", ""], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["margin-right:8px;width:max-content;"])), (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["&:last-child{margin-right:0px;}"])));
});
var StyledTextAreaAndCopyButtonContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledTextAreaAndCopyButtonContainer",
  componentId: "sc-el4wx8-11"
})(function(_ref5) {
  var theme = _ref5.theme;
  return (0, import_styled_components.css)(["display:flex;box-sizing:border-box;width:100%;height:172px;border:1px solid ", ";", " padding:10px 12px;justify-content:space-between;align-items:center;margin-top:32px;", ""], theme.colors.beige[180], (0, import_mixins.withBorderRadius)("4px"), (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["width:100%;height:92px;"])));
});
var StyledTextAreaAndLabelContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledTextAreaAndLabelContainer",
  componentId: "sc-el4wx8-12"
})(function() {
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;height:100%;width:100% margin-right:24px;"]);
});
var StyledLabel = (0, import_styled_components.default)(import_atoms.Label).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledLabel",
  componentId: "sc-el4wx8-13"
})(function(_ref6) {
  var theme = _ref6.theme;
  return (0, import_styled_components.css)(["font-size:", ";width:100%;"], theme.typography.sizes.small);
});
var StyledTextArea = import_styled_components.default.p.withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledTextArea",
  componentId: "sc-el4wx8-14"
})(function(_ref7) {
  var theme = _ref7.theme;
  return (0, import_styled_components.css)(["width:100%;padding:0px;margin:0px;color:", ";font-size:", ";font-family:", ";overflow-y:auto;word-break:break-all;white-space:break-spaces;", ""], theme.colors.n[100], theme.typography.sizes.small, theme.typography.fonts.primary, (0, import_mixins.withStyledScrollBar)());
});
var StyledCopyButton = (0, import_styled_components.default)(import_atoms.Button).withConfig({
  displayName: "GlobalHttpErrorPagestyled__StyledCopyButton",
  componentId: "sc-el4wx8-15"
})(function() {
  return (0, import_styled_components.css)(["", ""], (0, import_mixins.withPadding)("small"));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledAdditionalErrorMessage,
  StyledAllButtonsContainer,
  StyledButton,
  StyledCopyButton,
  StyledErrorImage,
  StyledErrorPageContainer,
  StyledHttpErrorCode,
  StyledHttpErrorMessage,
  StyledIcon,
  StyledImageBox,
  StyledLabel,
  StyledTextAndButtonContainer,
  StyledTextArea,
  StyledTextAreaAndCopyButtonContainer,
  StyledTextAreaAndLabelContainer,
  StyledTextMessageContainer
});
//# sourceMappingURL=GlobalHttpErrorPage.styled.js.map